import FocusLearningPathHeader from 'features/training/components/LearningPaths/Components/AssignedLearningPathDetails/FocusLearningPathHeader';
import React from 'react';
import CustomButton from 'shared_ui_components/CustomButton';
import styles from './DottedBtn.module.scss';
import { imageBasePath } from 'constants';

const FocusDottedBtn = ({ learningPath = {}, onClick, isPathOwner = true }) => {
  return (
    <>
      {Object.keys(learningPath).length > 0 && <FocusLearningPathHeader learningPath={learningPath} />}
      {isPathOwner && (
        <div className={styles.AddModulesBanner}>
          <div className={styles.AddModulesBannerText}>
            <img
              src={imageBasePath + 'sparkle_st.svg'}
              alt=""
              className={styles.AddModulesBannerImg}
            />
            <span>
              Help your team grow! Add skill sets to this skill path to boost your team’s sales
              skills
            </span>
          </div>
          <CustomButton onClick={onClick}>+ Add Skill Sets</CustomButton>
        </div>
      )}
    </>
  );
};

export default FocusDottedBtn;
